(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CalendarDetailController', CalendarDetailController);

    CalendarDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Calendar', 'Practice', 'Practitioner'];

    function CalendarDetailController($scope, $rootScope, $stateParams, previousState, entity, Calendar, Practice, Practitioner) {
        var vm = this;

        vm.calendar = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:calendarUpdate', function(event, result) {
            vm.calendar = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
